<div class="container-fluid widget-wrapper" #widgetHeader>
  <div class="row widget-header" [ngClass]="{ sticky: isTop }">
    <div class="col-lg-12">
      <h2>
        <span>Click Through</span><span class="app-title">&nbsp;{{ appName | appPrefix }}</span>
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body">
    <div class="col-lg-12">
      <app-ctr [data]="data" [isFreemium]="isFreemium"></app-ctr>
    </div>
  </div>
</div>
